import { theme, ThemeConfig } from "antd";
const primaryColor = "#29ABE2";
const primaryDarkColor = "#3c8068";
const yellowColor = "#faaf3a";
const yellowColorHover = "#eea736";
const Theme: ThemeConfig = {
  algorithm: theme.compactAlgorithm,
  components: {
    Table: {
      rowHoverBg: yellowColorHover,
      headerBg: yellowColor,
    },
    Tabs: {
      inkBarColor: "red",
      itemActiveColor: "#5ead8e",
    },
    Select: {
      optionSelectedColor: "white",
      optionSelectedBg: primaryColor,
      controlOutline: yellowColor,
      activeBorderColor: yellowColor,
    },
    Input: {
      colorPrimary: yellowColor,
      controlOutline: yellowColor,
    },
  },
  token: {
    fontFamily: "lato",
    fontSize: 16,
    colorPrimary: primaryColor,
    colorInfo: primaryColor,
    colorPrimaryBg: primaryDarkColor,
    colorLinkActive: primaryColor,
    colorLink: primaryColor,
    colorLinkHover: primaryDarkColor,
    borderRadius: 5,
  },
};
export default Theme;
